import { styled } from '@mui/material';

import Button from '../../../components/Button';
import { generateClasses } from '../../../utils/helper';
import { TileProps } from './types';

export const activityTileClasses = generateClasses('ActivityTile', ['root', 'icon', 'hoverIcon', 'active']);

export const Root = styled(Button)<Pick<TileProps, 'color'>>(({ theme, color = 'primary' }) => ({
  [`&.${activityTileClasses.root}`]: {
    width: 108,
    height: 96,
    border: `${theme.spacing(1)} solid ${theme.palette[color][500]}`,
    borderRadius: 0,
    backgroundColor: theme.palette[color][500],
    color: theme.palette.common.white,

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1.75),

    [`&:hover, &.${activityTileClasses.active}`]: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette[color][500],
      [`& .${activityTileClasses.icon}`]: {
        display: 'none',
      },
      [`& .${activityTileClasses.hoverIcon}`]: {
        display: 'flex',
      },
    },

    [`& .${activityTileClasses.icon}`]: {
      display: 'flex',
    },

    [`& .${activityTileClasses.hoverIcon}`]: {
      display: 'none',
    },
  },
}));

export const IconWrapper = styled('div')(() => ({
  width: 60,
  height: 60,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));
